import { Button } from "@mui/material";
import React from "react";

const ActionButtons = () => {
  return (
    <div className="flex w-full gap-4 mb-1">
      <Button
        className="px-8 text-sm normal-case bg-indigo-700 hover:bg-indigo-900 w-fit rounded-3xl"
        variant="contained"
      >
        Save
      </Button>
      <Button
        className="px-8 text-sm text-indigo-700 normal-case bg-white border-indigo-700 hover:border-indigo-700 w-fit rounded-3xl"
        variant="outlined"
      >
        Mark Complete
      </Button>
    </div>
  );
};

export default ActionButtons;
